module.exports = __webpack_public_path__ + "frontend/images/secure/keep-xs-0df03fbdc17339549905d66dcd477adc.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/secure/keep-xs.jpg
// module id = 330
// module chunks = 2